import { useAppNavigation } from 'contexts/navigation';
import { usePermissions } from 'hooks/permissions/usePermissions';
import { memo, ReactElement, useCallback } from 'react';
import { SingleContractPresentational } from './presentational';
import { SingleContractProps } from './types';

function SingleContract({ contract }: SingleContractProps): ReactElement {
  const { goToContractEdit } = useAppNavigation();
  const { canEditContract } = usePermissions();
  const editPermission = canEditContract();
  const edit = useCallback(() => {
    goToContractEdit(contract._id);
  }, [contract, goToContractEdit]);

  return (
    <SingleContractPresentational
      label={contract.label}
      parties={contract.parties}
      editDisabledReason={editPermission.reason}
      isEditButtonDisabled={!editPermission.permission}
      edit={edit}
    />
  );
}

export const MemoSingleContract = memo(SingleContract);
